import styled from "styled-components";

import { Typo } from "@enkor/design/components";

export const SignUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  padding: 80px 20px 0;
`;

export const Email = styled(Typo.Text)`
  width: 100%;
  margin-bottom: 16px;

  text-align: left;
`;

export const Title = styled(Typo.Heading)`
  width: 100%;
  margin-bottom: 20px;

  text-align: left;
`;

export const SignupForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  margin-top: 92px;
  margin-bottom: 60px;
`;
